export const
  FETCH_MARKETING_BOX_CONTENT_INITIATED = 'FETCH_MARKETING_BOX_CONTENT_INITIATED',
  FETCH_MARKETING_BOX_CONTENT_FAILURE = 'FETCH_MARKETING_BOX_CONTENT_FAILURE',
  FETCH_MARKETING_BOX_CONTENT_SUCCESS = 'FETCH_MARKETING_BOX_CONTENT_SUCCESS';
